import React, { useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { CustomModal } from "../../../Atom/Modals";
import FormButtons from "../../Buttons/FormButtons";
import Slider from "../../../Atom/Input/Slider";
import { getCroppedImg } from "./config/utils";
import { readFile } from "./config/utils";
import { dashboardColors, theme } from "../../../../themes/Theme";

const minZoom = 0.5;
const maxZoom = 3;

const CropModal = ({
	file,
	onlyCrop,
	closeCropModal,
	doUploadFile,
	cropModal,
	uploading = false,
	aspect
}) => {
	const [imgSrc, setImgSrc] = useState(null);
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
	//const [croppedImg, setCroppedImg] = useState(null);

	const onCropChange = cropValue => {
		setCrop(cropValue);
	};

	const onCropComplete = (croppedArea, croppedAreaPixelsValue) => {
		setCroppedAreaPixels(croppedAreaPixelsValue);
	};

	const onZoomChange = zoomValue => {
		setZoom(zoomValue);
	};

	const zoomIn = () => {
		if (zoom >= maxZoom) return;
		setZoom(zoom + 0.1);
	};

	const zoomOut = () => {
		if (zoom <= minZoom) return;
		setZoom(zoom - 0.1);
	};

	const uploadFile = async () => {
		const croppedImage = await getCroppedImg(imgSrc, croppedAreaPixels);
		if (!onlyCrop) doUploadFile(croppedImage);
		else return croppedImage;
	};

	useEffect(() => {
		updateImgSrc(file);
	}, [file]);

	const updateImgSrc = async fileValue => {
		if (fileValue) {
			const imageDataUrl = await readFile(fileValue);
			setImgSrc(imageDataUrl);
		}
	};

	return (
		<>
			<CustomModal
				header="Crop Image"
				openModal={cropModal}
				animation={true}
				keyboard={false}
				backdrop="static"
				width="50%"
				onClose={closeCropModal}
				isLoading={uploading}
				overflow="auto"
				content={
					<>
						<div className="mx-4 px-2 position-relative cropper-container">
							<Cropper
								minZoom={minZoom}
								maxZoom={maxZoom}
								image={imgSrc}
								crop={crop}
								zoom={zoom}
								aspect={aspect}
								restrictPosition={false}
								onCropChange={onCropChange}
								onCropComplete={onCropComplete}
								onZoomChange={onZoomChange}
								zoomWithScroll={false}
							/>
						</div>
						<div className="zoom-container d-flex mt-4 mb-3">
							<div className="d-flex slider-container">
								<div className="d-flex flex-grow-1 zoom-icons" onClick={zoomOut}>
									<i className="fas fa-minus-circle" />
								</div>
								<Slider
									min={minZoom}
									max={maxZoom}
									value={zoom}
									onChange={onZoomChange}
									step={0.1}
								/>
								<div className="d-flex flex-grow-1 zoom-icons" onClick={zoomIn}>
									<i className="fas fa-plus-circle" />
								</div>
							</div>
						</div>
						<div className="w-100 mb-2">
							<FormButtons
								onSave={uploadFile}
								onCancel={closeCropModal}
								saveBtnContent={"Save"}
								cancelBtnDisabled={false}
								isLoading={uploading}
								saveBtnDisabled={uploading}
							/>
						</div>
					</>
				}
			></CustomModal>
			<style jsx global>{`
				.cropper-container {
					height: 400px;
					background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);
				}

				.modal {
					// margin-left: 125px;
					top: 100 !important;
					z-index: 10000;
					display: flex !important;
				}

				.modal-backdrop {
					position: fixed !important;
					top: 100 !important;
					left: 0;
					z-index: 1040;
					width: 100vw;
					height: 100vh;
					background-color: #000;
				}

				.modal-header {
					border-bottom: 0 none;
				}

				.modal-footer {
					border-top: 0 none;
				}

				.custom-save-cancel-uploader {
					width: auto !important;
				}

				.zoom-container {
					justify-content: center;
					align-items: center;
				}

				.zoom-container .slider-container {
					width: 75%;
				}

				.zoom-container .slider-container .zoom-icons {
					margin: 0 15px;
					cursor: pointer;
				}

				.zoom-container .slider-container .zoom-icons i {
					font-size: 18px;
					color: ${dashboardColors[theme].primaryTextColor};
				}
			`}</style>
		</>
	);
};

export default CropModal;
